<template>
    <div class="w-full">
        <custom-simple-select
            v-model="option"
            label="Tipo de identificación"
            class="min-w-full"
            :options="selectOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { identificationTypes } from "@/common/fields/identification-types";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "IdentificationTypeSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: String,
            default: () => "cc",
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data() {
        return {
            option: this.itemCurrent,
            $enabledOptions: identificationTypes
        };
    },
    computed: {
        selectOptions() {
            return Object.entries(this.$data.$enabledOptions).map(
                ([key, value]) => ({ label: value, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.option = value;
        }
    },
    methods: {
        onInput(value) {
            this.$emit("change", value);
        }
    }
};
</script>
